import TrainlineHomeWidget from './TrainlineHomeWidget';

export default TrainlineHomeWidget;